import {Component, Injector, Input, OnChanges, OnInit, ViewEncapsulation} from '@angular/core';
import {ButtonOptions} from '../eva-button/eva-button.component';
import {TagTextData} from '../tag-text/tag-text.component';
import {PictureData} from 'projects/common/components/picture/picture.component';
import { AbstractComponent } from '../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';

type TextListData = ButtonOptions & {
    text: string;
    tag: string;
    subtitle?: TagTextData;
    picture?: PictureData;
};

type TextListObject = {
    title: TagTextData;
    data: TextListData;
}

@Component({
    selector: 'text-list',
    template: `
        <div class="eva-3-card -eva-3-shadow-line" *ngIf="module.data !== null && module.data.length > 0">
            <ng-template ngFor let-item [ngForOf]="module.data">
                <div class="text">
                    <text [data]="{title: item.title, subtitle: item.data.subtitle, text_data: {text: item.data.text, tag: item.data.tag}}"></text>
                    <eva-button *ngIf="item.data.link_text" [options]="item.data" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></eva-button>
                </div>
                <div class="img" *ngIf="item.data.picture">
                    <img class="picture"
                        loading="lazy"
                        [alt]="item.data.picture.alt || item.data.picture.alt_mobile"
                        [src]="screenType === 'MOBILE' ? item.data.picture.src_mobile : item.data.picture.src"
                    >
                </div>
            </ng-template>
        </div>
    `,
    styleUrls: ['./text-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TextListComponent extends AbstractComponent implements OnInit {
    private static MODULE_ID: string = "TextListModule";

    @Input() override module: Module<TextListObject[]>;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        const landingModel = this.landingModelService.getLandingModel();
        this.screenType = landingModel.device.type;
    }

    getModuleId() {
        return TextListComponent.MODULE_ID;
    }

}
